import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29f82c96"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "alltable"
}
const _hoisted_2 = { class: "clb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"18px","font-weight":"400","font-size":"14px","line-height":"18px","text-align":"center","color":"#333333"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "RMB消费")
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "infor" }
const _hoisted_7 = { class: "top" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "查看信息开票", -1))
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont" }, "", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发票将通过快递的方式邮寄,请注意查收。", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发票信息相关问题>>", -1))
const _hoisted_13 = { class: "type" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type1" }, "发票类型", -1))
const _hoisted_15 = {
  key: 0,
  class: "p1"
}
const _hoisted_16 = {
  key: 1,
  class: "p1"
}
const _hoisted_17 = {
  key: 2,
  class: "type2"
}
const _hoisted_18 = {
  key: 3,
  class: "p2"
}
const _hoisted_19 = {
  key: 4,
  class: "p2"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("p", null, "开票信息")
], -1))
const _hoisted_21 = {
  key: 0,
  class: "name"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "个人名称", -1))
const _hoisted_23 = {
  key: 1,
  class: "name"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "单位名称", -1))
const _hoisted_25 = {
  key: 2,
  class: "name"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "单位税号", -1))
const _hoisted_27 = {
  key: 3,
  class: "name"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "单位地址", -1))
const _hoisted_29 = {
  key: 4,
  class: "name"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "单位电话", -1))
const _hoisted_31 = {
  key: 5,
  class: "name"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开户银行", -1))
const _hoisted_33 = {
  key: 6,
  class: "name"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "银行账号", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "names" }, [
  /*#__PURE__*/_createElementVNode("p", null, "发票内容"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "商品明细"),
    /*#__PURE__*/_createElementVNode("p", { class: "shuoming" }, " (发票内容将显示详细商品名称与价格信息，如有特殊需求请联系客服) ")
  ])
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("p", null, "收票信息")
], -1))
const _hoisted_37 = { class: "address" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "收票地址", -1))
const _hoisted_39 = { class: "right" }
const _hoisted_40 = { class: "top" }
const _hoisted_41 = { class: "user" }
const _hoisted_42 = { class: "phone" }
const _hoisted_43 = { class: "footer" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footed" }, "发票随货物一同寄出，请注意查收!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lack_record_vue = _resolveComponent("lack-record-vue")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Title = _resolveComponent("Title")!
  const _component_InvoiceFrom = _resolveComponent("InvoiceFrom")!
  const _component_InvoiceDialog = _resolveComponent("InvoiceDialog")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.AccountToSon.data.total <= 0)
      ? (_openBlock(), _createBlock(_component_lack_record_vue, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.AccountToSon.data.total > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_table, {
            data: _ctx.AccountToSon.data.list,
            class: "table",
            stripe: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "ctime",
                label: "交易时间"
              }),
              _createVNode(_component_el_table_column, {
                prop: "money",
                label: "RMB/元"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, "¥" + _toDisplayString(scope.row.money), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "type",
                label: "交易类型",
                width: "184px"
              }, {
                default: _withCtx((scope) => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "detail",
                label: "订单编号",
                width: "235px"
              }),
              _createVNode(_component_el_table_column, {
                prop: "status1",
                label: "开具发票"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.status1 == '3')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "invoice",
                        style: {"font-style":"normal","font-weight":"400","font-size":"14px","text-align":"center","color":"#999","cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.setDialogVisibles(scope.$index))
                      }, " 已开票 ", 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  (scope.row.status1 == '1')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        text: "",
                        class: "invoice1",
                        style: {"font-size":"12px","width":"72px","height":"26px","border-radius":"2000px","text-align":"center","border":"#2655ae 1px solid","color":"#2655ae"},
                        onClick: ($event: any) => (_ctx.setDialogVisible(scope.$index))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 申请开票 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (scope.row.status1 == '2')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "invoice2",
                        style: {"font-style":"normal","font-weight":"400","font-size":"14px","text-align":"center","color":"#999","cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.setDialogVisibles(scope.$index))
                      }, " 已申请 ", 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRef",
      dialogwidth: "625px",
      addressItems: _ctx.addressItem,
      lastInfor: _ctx.lastInfor
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          default: _withCtx(() => [
            _createElementVNode("template", null, [
              _createElementVNode("i", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mclose())),
                class: "icon iconfont icon-shanchu"
              })
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({ addressItems }) => [
        _createVNode(_component_InvoiceFrom, {
          onMclose: _ctx.mclose,
          lastInfor: _ctx.lastInfor,
          recordId: _ctx.recordId,
          goShow: _ctx.goShow,
          from: _ctx.from,
          onChangeGoShow: _ctx.changeGoShow
        }, null, 8, ["onMclose", "lastInfor", "recordId", "goShow", "from", "onChangeGoShow"])
      ]),
      _: 1
    }, 8, ["addressItems", "lastInfor"]),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRefs",
      dialogwidth: "625px",
      class: "invoiceinfor"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          default: _withCtx(() => [
            _createElementVNode("template", null, [
              _createElementVNode("i", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mcloses())),
                class: "icon iconfont icon-shanchu"
              })
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({ addressItems }) => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("i", {
              class: "icon iconfont icon-shanchu",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mcloses()))
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createVNode(_component_router_link, { to: {
              name: 'customer',
              params: {
                comName: 'Fapiao',
              },
            } }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            (!_ctx.information.data.bank_nu)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, "普通发票"))
              : _createCommentVNode("", true),
            (_ctx.information.data.bank_nu)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, "增值税专用发票"))
              : _createCommentVNode("", true),
            (!_ctx.information.data.bank_nu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, "抬头类型"))
              : _createCommentVNode("", true),
            (!_ctx.information.data.company)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, "个人"))
              : _createCommentVNode("", true),
            (_ctx.information.data.company)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, "单位"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_20,
          (_ctx.information.data.people != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", null, _toDisplayString(_ctx.information.data.people), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.information.data.company != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", null, _toDisplayString(_ctx.information.data.company), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.information.data.duty != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", null, _toDisplayString(_ctx.information.data.duty), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.information.data.com_address != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", null, _toDisplayString(_ctx.information.data.com_address), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.information.data.com_mobile != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", null, _toDisplayString(_ctx.information.data.com_mobile), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.information.data.bank != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", null, _toDisplayString(_ctx.information.data.bank), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.information.data.bank_nu != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", null, _toDisplayString(_ctx.information.data.bank_nu), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_35,
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.information.data.name), 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.information.data.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.information.data.province), 1)
            ])
          ]),
          _hoisted_44
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}